// extracted by mini-css-extract-plugin
export var btn = "G_mB v_sH v_sq d_bz d_bP d_bD d_dw";
export var full = "G_vD d_w d_H";
export var hoverStyle = "G_mF";
export var zoom = "G_mG";